import { NgModule } from '@angular/core';
import { SlidePageComponent } from 'src/app/core/components/mobile/slide-page/slide-page.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [ CommonModule ],
  declarations: [ SlidePageComponent ],
  exports: [  SlidePageComponent ]
})
export class slidePageModule { }